export const roleNames = {
  Teacher: "teacher",
  DepartmentManager: "departmentManager",
  Administrator: "administrator",
  Tutor: "tutor",
  Parent: "parent",
  Pupil: "pupil",
};
